import { LogLevel } from "@microsoft/signalr";
import { DbObjectCreateOrUpdateInfos } from "./db-object-create-or-update-infos";

export enum Operator {
  Equals,
  NotEquals,
  Contains,
  NotContains,
}

export enum KalikoNodeType {
  Undefined = "Undefined",

  StartEvent = "StartEvent",
  EndEvent = "EndEvent",

  GatewayExclusive = "GatewayExclusive",
  GatewayInclusive = "GatewayInclusive",
  GatewayParallel = "GatewayParallel",
  Timer = "Timer",

  CallJobRule = "CallJobRule",
  SetMetadata = "SetMetadata",
  GetMetadata = "GetMetadata",
  CallWorkflow = "CallWorkflow",
  UserTask = "UserTask",
  ChangeStatus = "ChangeStatus",
  FSDeleteFile = "FSDeleteFile",
}

export enum KalikoNodeStatus {
  Undefined = "Undefined",
  Pending = "Pending",
  Running = "Running",
  Completed = "Completed",
  Failed = "Failed",
  Skipped = "Skipped",
  Cancelled = "Cancelled",
}
enum DataType {
  String,
  Long,
  Boolean,
}
export interface KalikoNodeParam {
  name: string;
  value: string;
  type: DataType;
  optional: boolean;
}
enum KalikoNodeProcessingMode {
  Sync = 0,
  Async = 1,
}

export interface KalikoLog {
  level: LogLevel;
  msg: string;
  date: Date;
}

enum KalikoContinueResponse {
  Ok,
  End,
  Waiting,
}

enum KalikoWorkflowStatus {
  Pending,
  Running,
  Failed,
  Cancelled,
  Completed,
}

export interface IKalikoNode {
  //$id: string;
  position?: { x: number; y: number };
  $type: string;
  name?: string;
  systemName?: string;
  type: KalikoNodeType;
  uid: string;
  mode: KalikoNodeProcessingMode;
  status: KalikoNodeStatus;
  progress: number;
  inputParams: KalikoNodeParam[];
  condition: KalikoCondition | null;
  logs: KalikoLog[];
}

export interface KalikoWorkflowVariable {
  name: string;
  value: string;
}

interface KalikoWorkflowModel {
  abstractWorkflowId?: number;
  kalikoExecWorkflowId?: number;
  masterKalikoExecWorkflowId?: number;
  retries: number;
  vars: KalikoWorkflowVariable[];
  nodes: IKalikoNode[];
  links: KalikoWorkflowLink[];
  ownerUserId?: number;
  subscribeOnNodeChanges: boolean;
  parallelGatewayAbortNodeIfAnyBranchFailed: boolean;
  parallelGatewayContinueBranchesInCaseOfBranchFailed: boolean;
}

export interface GetKalikoBPMWorkflowExecResponse {
  exec: DbKalikoWorkflowExecInfos;
}

export interface DbKalikoWorkflowExecInfos {
  platformId: number;
  guid: number;
  createdAt: Date;
  startAt?: Date;
  endAt?: Date;
  definitionId: number;
  name: string;
  model: KalikoWorkflowModel;
}

export interface DbKalikoWorkflowModelInfos {
  id: number;
  name: string;
  description: string;
  version: number;
  enabled: boolean;
  created: DbObjectCreateOrUpdateInfos | null;
  updated: DbObjectCreateOrUpdateInfos | null;
  model: KalikoWorkflowModel;
}

export interface KalikoCondition {
  lettersPattern?: string;
  regexGlobalVar?: string;
  regexNodeOutputVar?: string;
  left: string;
  right: string;
  op: Operator | null;
  model?: KalikoWorkflowModel | null;
}

export interface KalikoWorkflowLink {
  name?: string;
  sourceUid: string;
  targetUid: string;
  condition: KalikoCondition | null;
}

export interface KalikoNodeBase {
  name?: string;
  type: KalikoNodeType;
  position?: { x: number; y: number };
  uid: string;
  status: KalikoNodeStatus;
  progress: number;
  inputParams: KalikoNodeParam[];
  outputParams: KalikoNodeParam[];
  defaultInputParams: KalikoNodeParam[];
  defaultOutputParams: KalikoNodeParam[];
  condition: KalikoCondition | null;
  logs: KalikoLog[];
  execTime?: Date;
  endTime?: Date;
}

export interface KalikoNodeCallJobRule extends KalikoNodeBase, IKalikoNode {
  objectId: number;
  ruleName: string;
  jobId?: number;
  priority: number;
}

export interface KalikoNodeCallWorkflow extends KalikoNodeBase, IKalikoNode {
  workflowName: string;
  workflowId: number;
}

export interface KalikoNodeGatewayBase extends KalikoNodeBase, IKalikoNode {}

export interface KalikoNodeGetMetadata extends KalikoNodeBase, IKalikoNode {
  objectId: number;
  tagName: string;
  value: string;
}

export interface KalikoNodeSetMetadata extends KalikoNodeBase, IKalikoNode {
  objectId: number;
  tagName: string;
  value: string;
}

export interface KalikoNodeStartEndEventBase extends KalikoNodeBase, IKalikoNode {}

export interface KalikoNodeTimer extends KalikoNodeBase, IKalikoNode {
  valueSeconds: number;
}
